import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fileUrl = (path) => `${API}/files/${path}`;
export const publicFileUrl = (token, path) => `${API}/public/batch/${token}/file/${path}`;

export const driveEmbed = (link) => {
  if (!link) return null;
  const m = link.match(/\/d\/([^/]+)/) || link.match(/[?&]id=([^&]+)/);
  if (m) return `https://drive.google.com/file/d/${m[1]}/preview`;
  return null;
};

export const homePathForRole = (role) => {
  if (role === "client") return "/portal";
  if (role === "editor") return "/assigned-briefs";
  return "/dashboard";
};

export const BRIEF_STAGES = ["Not Started", "In Edit", "In Review", "Approved", "Launched"];

export default api;
